import { render, staticRenderFns } from "./eic-dashboard.vue?vue&type=template&id=1062ce54&scoped=true"
import script from "./eic-dashboard.vue?vue&type=script&lang=js"
export * from "./eic-dashboard.vue?vue&type=script&lang=js"
import style0 from "./eic-dashboard.vue?vue&type=style&index=0&id=1062ce54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1062ce54",
  null
  
)

export default component.exports